import { createSlice } from "@reduxjs/toolkit";

const initialState = {};

const imageSlice = createSlice({
  name: "image",
  initialState,
  reducers: {
    setImage: (state, action) => {
      return { image: action.payload };
    },
    clearImage: (state) => {
      return { image: "" };
    },
  },
});

export const imageReducer = imageSlice.reducer;
export const { setImage, clearImage } = imageSlice.actions;
// export default reducer;
